﻿// Delay execution until DOM is ready AND jQuery is available
function initSiteSearchAutocomplete() {
  const $ = window.jQuery || window.$;
  
  if (!$ || typeof $.fn.typeahead !== 'function') {
    console.error('jQuery or typeahead not available');
    return;
  }

  var results = new Bloodhound({
    datumTokenizer: function (datum) {
      return Bloodhound.tokenizers.whitespace(datum.value);
    },
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      wildcard: "%QUERY",
      url: "/api/siteautocomplete/simple?query=%QUERY",
      // url: "https://4097e903-9416-4ee4-9e79-07dabf4a98fc.mock.pstmn.io/typeahead",
      transform: function (data) {
        return $.map(data, function (data) {
          return {
            title: data.title,
            url: data.url,
            type: data.type,
            breadcrumbHtml: data.breadcrumbHtml,
          };
        });
      },
    },
  });

  var typeaheadReference = $(".js-sitesearch-autocomplete").typeahead(
    {
      minLength: 2,
      highlight: true,
    },
    {
      limit: 10,
      source: results,
      templates: {
        suggestion: function (data) {
          var layout = '<a href="' + data.url + '" class="tt-suggestion--other">';
          layout += "<h3>" + data.title + "</h3>";
          if (data.breadcrumbHtml) {
            layout += data.breadcrumbHtml;
          }
          layout += "</a>";
          return layout;
        },
      },
    }
  );

  var searchTop = $("#search-top");
  searchTop.on("shown.bs.collapse", function () {
    if (typeaheadReference[0] != null && typeaheadReference[0] != undefined) {
      typeaheadReference[0].focus();
    }
  });
}

// Export for manual initialization or call when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSiteSearchAutocomplete);
} else {
  initSiteSearchAutocomplete();
}

export { initSiteSearchAutocomplete };